import { createStore } from 'vuex'
import { userModule } from './Modules/UserModule'
import { confirmModule } from './Modules/ConfirmModule'

const store = createStore({
    modules: {
        user: userModule,
        confirm: confirmModule
    }
})

export default store
